import { Toast } from "antd-mobile";
import { ToastHandler } from "antd-mobile/es/components/toast";

export type TToastHandler = ToastHandler;

const SJToast = {
  clear: () => Toast.clear(),
  loading: (
    content = "",
    config?: { maskClickable?: boolean },
  ): ToastHandler => {
    return Toast.show({
      icon: "loading",
      content,
      duration: 0,
      maskClickable: config?.maskClickable || true,
    });
  },
  info: (content: string) => {
    Toast.show({
      content,
    });
  },
  success: (content: string) => {
    Toast.show({
      icon: "success",
      content,
    });
  },
  fail: (content: string) => {
    Toast.show({
      icon: "fail",
      content,
      duration: 3000,
    });
  },
};

export default SJToast;
